import * as React from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import { useOfferMode } from "@nju/data-access-portal-offers";
import { pushSimpleEvent } from "@nju/data-layer";
import { Icon } from "@nju/icons";
import { portalRoutes } from "@nju/routes";
import { A, Button, Panel, Separator, Text } from "@nju/ui";

interface IWrongSimCodeProps {
  userId: string | undefined;
}

export function WrongSimCode({ userId }: IWrongSimCodeProps) {
  const mode = useOfferMode();
  const router = useRouter();

  React.useEffect(() => {
    pushSimpleEvent({
      event: "error_add_sim_card",
      eventName: "WrongNumberShort",
    });
  }, []);

  const refresh = React.useCallback(() => {
    router.reload();
  }, [router]);

  return (
    <Panel>
      <div className="flex items-center flex-col">
        <Text
          align="center"
          size={{
            "@onlyMobile": "xl",
            "@fromTablet": "keyM",
          }}
          weight="bold"
        >
          ten numer jest niewłaściwy
        </Text>
        <Separator size="s" tone="invisible" />
        <Icon
          className="w-12 h-12 from-tablet:w-[90px] from-tablet:h-[90px]"
          name="sim-card-error-incircle"
        />
        <Separator size="s" tone="invisible" />
        <Text
          align="center"
          size={{
            "@onlyMobile": "s",
            "@fromTablet": "l",
          }}
        >
          Upewnij się, że wpisujesz 4 ostatnie cyfry nowej karty SIM, która nie
          była wcześniej używana.
        </Text>
      </div>
      <Separator size="s" tone="invisible" />
      <div className="flex justify-center only-mobile:flex-col-reverse">
        <Link
          href={portalRoutes.mojeKonto.dodajPelnySim.get({
            mode,
            ...(userId && { userId }),
          })}
          passHref={true}
        >
          <A
            className="from-tablet:mr-5 only-mobile:mt-2"
            size={{
              "@onlyMobile": "s",
            }}
            variant="secondary"
          >
            wpisz ręcznie numer karty
          </A>
        </Link>
        <Button onPress={refresh} size={{ "@onlyMobile": "s" }}>
          spróbuj ponownie
        </Button>
      </div>
    </Panel>
  );
}
